import { render, staticRenderFns } from "./DadosEnvio.vue?vue&type=template&id=661f8c36"
import script from "./DadosEnvio.vue?vue&type=script&lang=js"
export * from "./DadosEnvio.vue?vue&type=script&lang=js"
import style0 from "./DadosEnvio.vue?vue&type=style&index=0&id=661f8c36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports